<template>
  <div>
    <nav class="navbar   is-fixed-top " :class="background_colour" role="navigation" aria-label="main navigation">
  <div class="navbar-brand  ">
    <a href="/" class="navbar-item mr-6" >
      <img :src="navbar_logo" />
    </a>

    <a href="/bookings/new#pending"><button class="button is-danger m-1" v-if="app_replies.length > 0">{{ app_replies.length }} App Replies</button></a>
    


  </div>
  <div class="buttons  navbar-end">
    <button class="button  m-1 " :class="{'is-danger' : this.newNotesToView ==true, 'is-light' : this.newNotesToView ==false}" style="" @click="openNotesModal()">Notes&nbsp;<span v-if="this.unreadNotesCount > 0"> ({{ this.unreadNotesCount }})</span></button>
    <a href="/on-call" style="display:none"><button class="button is-info m-1 mr-4">On Call</button></a>  
    <a href="/members"><button class="button is-success m-1">Members</button></a>
      <a href="/bookings/new"><button class="button is-warning m-1">Bookings</button></a>
      <a href="/applications/dashboard-new"><button class="button is-light m-1">Applications</button></a>
      
    </div>



 
</nav>


<div class="modal" :class="{'is-active' : this.showNotesModal == true}">
      <div class="modal-background" @click="showNotesModal = false"></div>
      <div class="modal-content">
        <div class="box content">
          <a href="/notes"><button class="mb-4 button is-link">View All Notes</button></a>
          
          <blockquote v-for="row in notes"  :key="row.id" :class="{'has-background-success-light': row.note_read === null}" style="border-left: 5px solid #3273dc; padding-left: 10px; margin-bottom: 15px;">
            <button class="button is-small is-link " style="float:right" @click="markNoteAsRead(row)" v-if="row.note_read === null">I've Read This</button>
            <strong>Added by {{ row.forename }} {{ row.surname }} - {{ row.formatted_date }}</strong> <br />
            <span v-html="row.text"></span> 
           <br /> 
          
           <button class="button is-small is-danger " style="display:none">Delete For All</button>
          </blockquote>
          
        </div>
        
      </div>
      <button class="modal-close is-large" aria-label="close" @click="showNotesModal = false"></button>
    </div>

</div>

</template>

<script>
import UtilityService from '@/services/UtilityService.js';
import NoteService from '@/services/NoteService.js';

export default {
  name: 'NavBar',
  components: {
    
  },
  data: function () {
        return {
                API_NAME: process.env.VUE_APP_API_NAME,
                background_colour: process.env.VUE_APP_NAVBAR_COLOUR,
                accessToken: '',
                user: [],
                loading: true,
                app_replies: 0,
                showNotesModal: false,
                newNotesToView: false,
                navbar_logo: process.env.VUE_APP_NAVBAR_LOGO,
                notes: [],
                unreadNotesCount: 0
               
        }
    },
  methods: {
      async markNoteAsRead(row) {
          this.working = true
          
          NoteService.markNoteAsRead(this.accessToken, row.id)
          .then((response) => {
              console.log(response)
              row.note_read = 1;
              }).catch((error) => {
                  if(error.response.status === 422)
                  {
                      console.log("Error:" + JSON.stringify(error.response.data));
                  }
                  alert("Something went wrong. ")
                  
          })
          .finally(() => {
              this.working = false
          })
      },
      logout() {
              if(confirm('Are you sure you want to logout ?'))
              {
                  this.$auth.logout({
                  returnTo: window.location.origin
                });
              }
      },
      openNotesModal() {
        this.checkNotes()
        this.showNotesModal = true
        //this.newNotesToView = false
      },
      async getAppReplies() {
          

          UtilityService.getSimpleApiData(this.accessToken, "member_alerts?interested=1&assigned=0")
                .then(
                    (app_replies => {
                        this.$set(this, "app_replies", app_replies);
                        
                    }).bind(this)
                );
          
      },
      async checkNotes() {
        UtilityService.getSimpleApiData(this.accessToken, "notes")
                .then(
                    (notes => {
                        this.$set(this, "notes", notes);
                        
                    }).bind(this)
                ).finally(() => {
                    this.newNotesToView = this.notes.some(note => note.note_read === null);
                    this.unreadNotesCount = this.notes.filter(note => note.note_read === null).length;
                    
                });
      }
    },
    async mounted() {
          
          
                
                
                setTimeout(() => {
                  this.getAccessToken().then(() => {
                    this.checkNotes();
                    this.getAppReplies();
                  });
                 
                }, 2000);

                setInterval(() => {
                  this.getAppReplies()
                }, 110000);

                setInterval(() => {
                  this.checkNotes()
                }, 130000);
           
           
          
        },
}
</script>